import { StyledDisplayItemsPerPageSelect } from 'components/DisplayItemsPerPageSelect/styles';
import styled from 'styled-components';
export const StyledAdminEditPaymentHistory = styled.div`
  .admin-edit-history-controls {
    display: flex;
    gap: 1rem;
    width: 100%;

    &__right {
      display: flex;
      gap: 1.2rem;
      margin-left: auto;

      @media screen and (max-width: 1200px) {
        margin-bottom: 0;
        flex-wrap: wrap;
        flex-shrink: 1;
        flex-grow: 1;
        min-width: 0;
      }
    }

    @media screen and (max-width: 1200px) {
      margin-bottom: 0;
      flex-wrap: wrap;
      flex-shrink: 1;
      flex-grow: 1;
      min-width: 0;
    }
  }

  .admin-edit-history-list-body {
    min-height: 37rem;
  }

  .list-body-pagination {
    display: flex;
    justify-content: center;
    padding: 0 2.4rem 2rem;

    @media screen and (min-width: 768px) {
      justify-content: space-between;
    }

    ${StyledDisplayItemsPerPageSelect} {
      display: none;

      @media screen and (min-width: 768px) {
        display: flex;
      }
    }
  }
`;
